import script from "./CreateAgent.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateAgent.vue?vue&type=script&setup=true&lang=js"

import "./CreateAgent.vue?vue&type=style&index=0&id=35c8e63a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35c8e63a"]])

export default __exports__